import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs';
import { List2Res, PageInfo, Pageable, Team, TeamRequest, User } from 'src/app/shared';
import { environment } from 'src/environments/environment';
import * as queryString from 'query-string';

@Injectable({
  providedIn: 'root'
})

export class TeamService extends EntityCollectionServiceBase<Team> {
  public page$: Observable<PageInfo> = new Observable();

  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    private http: HttpClient
    ) {
    super('teams', serviceElementsFactory);
    this.page$ = this.selectors$['page$'];
  }

  addMembers(teamId: number, payload: {userIds: number[]}): Observable<User[]> {
    return this.http.post<User[]>(`${environment.apiUrl}/teams/${teamId}/add-member`, payload);
  }

  removeMembers(teamId: number, payload: {userIds: number[]}) {
    return this.http.request('delete', `${environment.apiUrl}/teams/${teamId}/remove-member`, { body: payload });
  }

  getMembers(teamId: number, query: string = ''): Observable<List2Res<User>> {
    return this.http.get<List2Res<User>>(`${environment.apiUrl}/teams/${teamId}/members?${query}`);
  }

  getTeams(query: TeamRequest , pageable: Pageable) {
    const params = queryString.stringify({ ...query, ...pageable});
    return this.http.get<List2Res<Team>>(`${environment.apiUrl}/teams/?${params}`);
  }
}
